import { renderRegisteredIcon } from './registry.fabric';
/**
 * Thin shell — imports no vendor package. At migration, only the import
 * line above changes to point at the new registry.
 */ var TFIcon = function TFIcon(props) {
    return renderRegisteredIcon(props);
};
export default TFIcon;
